import React, {useContext, useEffect, useState} from 'react'
import {Passaggio, User} from '../App';
import {useNavigate} from 'react-router-dom'
import '../Carrello/Carrello.css'
import Swal from 'sweetalert2'

const Carrello = () => {
    const Contesto=useContext(Passaggio)
    const utente = useContext(User)
	const [carrello, setcarrello] = useState([])
    const link=useNavigate() 
    useEffect(() => {
        crea_el()
    }, [Contesto.ordine]);
    if(sessionStorage.getItem("token")===null){
        link("/")
    }
    //Creo elementi (prodotti del carrello), li inserisco nel vettore 'elem'
    //Infine setto il carrello
    const crea_el=()=>{
		let elem = []
        Contesto.ordine.forEach((el,i)=>{
            elem.push(
                <div className='pulsante' >   
                    <div className='formattatesto' >{el.prodotto}</div>
                    <div className='formattainfo' >PREZZO: {el.prezzo}€</div>
                    <div className='formattainfo' >QTA: {el.qta}</div>
                        <div onClick={()=>elimina(el,i)}>
                            <div className='elimina'><div className='sposta'>-</div></div>
                        </div>
                </div>
            )
        })
        setcarrello(elem)
	}
    //Funzione per rimuovere prodotti dal carrello
    //Se la quantità è uguale a 1 elimino direttamente il prodotto
    //Altrimenti se quantità > 1, decremento quantità, mi ritorna l'item prodotto
    const  elimina = (el,i) => {
        Contesto.setqta(qta=>qta-1)

        Contesto.setordine(Contesto.ordine.filter( (item,ind) => {
            if(ind !== i){
                return item
            }else{
                Contesto.settotale(totale=>totale-item.prezzo)
                if(item.qta>1){
                    item.qta--
                    return item
                }
            } 
        }))
	}
    //Creo literal object per ordinazione
    //Salvo info dell'utente (grazie a contest e sessionStorage)
    //Nella sezione prodotti, ritorno le info relative a ogni prodotto
    const creaOrdine =()=>{
        Contesto.setidOrdine(Contesto.idOrdine+1)
		let ord
        ord = {
            ordineID: Contesto.idOrdine,
            user: sessionStorage.getItem('token'),
            email: sessionStorage.getItem('token'),
            cittaID: sessionStorage.getItem('idCitta'),
            localeID: sessionStorage.getItem('idLocale'),
            importoTotale: Contesto.totale,
            prodotti: Contesto.ordine.map(item => {
                return {
                    prodottoID: item.idProd,
                    prodottoDesc: item.prodotto,
                    prezzoUnitario: item.prezzo,
                    quantita: item.qta
                }
            })
        }
        //Richiamo funzione per effettuare ordinazione, passo il literal object come parametro alla funzione
        effettuaOrdinazione(ord)
        //Imposto totale a 0 in quanto l'ordine è stato effettuato
        Contesto.settotale(0)
        //Svuoto l'ordine
        Contesto.setordine([])
        Contesto.setqta(0)
    }
    //Funzione per inviare l'ordinazione al server
    //Passo l'oggetto ordinazione come parametro
    const effettuaOrdinazione =(ordinazione)=>{
		let ord = {ordine:[ordinazione]}
        const link = 'http://37.60.34.42:8080/ordinazione'
		fetch(link, {
			method: 'POST',
			headers: {
				'Accept':'application/json',
				'Content-Type':'application/json'
			},
			body: JSON.stringify(ord)
		})
		.then(response => response.json())
		.then(data => {
            //Se il server memorizza correttamente le info allora confermo all'utente
            //Altrimenti comunico che l'ordinazione non è andata a buon fine
			if(data.ordine.includes('OK')){
                Swal.fire({  title: 'Il tuo ordine è stato inviato!', timer:1500,showConfirmButton:false,  icon: 'success', width:"65vw"})    
            } else {
                Swal.fire({  title: 'Ordine non inviato!', timer:1500,showConfirmButton:false,  icon: 'warning', width:"65vw"}) 
			}
		})
	}

    return (
        //Avviso di ordini max 15 euro
        //Se nel carrello non ci sono prodotti, allora imposto scritta "Carrello vuoto"
        //Altrimenti visualizzo carrello
    <div className='contCarrello'>
        <div className='avviso'>ORDINE MAX 15 EURO</div>
    <div className='tot'>TOTALE: {Contesto.totale}€</div>
        {
            Contesto.ordine.length===0 ? <div className='vuoto'>CARRELLO VUOTO</div> : 
            <>
                {carrello}
            {
                //Se il totale è <= di 15 euro allora utente può ordinare
                //Altrimenti non visualizzo button così l'utente non può fare ordini non validi
                Contesto.totale<=15 ? <div className='ordina' onClick={()=>creaOrdine()}><div>ORDINA</div></div>:null
            }
            </>
        }
    </div>
    )
}

export default Carrello
